import RegistrationLoginModal from '../components/Modals/RegistrationLoginModal.jsx';
import ThankYouModal from '../components/Modals/ThankYouModal.jsx';
import DummyModal from '../components/Modals/DummyModal.jsx';

export const modalMap = {
    "staticContent": ({ schema }) => <div>{schema.title}{schema.subtitle && <p>{schema.subtitle}</p>}</div>,
    "RegistrationLoginModal": RegistrationLoginModal,
    "ThankYouModal": ThankYouModal,
    "DummyModalForTest": DummyModal,
};